"use strict";

angular.module('app.modals.offsetValue', [])

    .controller('offsetValueModalCtrl', ['$scope', 'close', 'f_User','Datapoints',
        function ($scope, close, f_User,  Datapoints) {

            //var userLevel =f_User.getUserLevel();
            $scope.close = function () {
                close();
            };

            $scope.init = function () {
                console.debug('Probably deprecated! offsetValueModalCtrl initiated');
                $scope.Datapoints = Datapoints;
            }
            $scope.save = function () {
                close($scope.Datapoints);
            }

            $scope.init();
        }
    ])

    .factory('offsetValueModal', ['ModalService', '$q', function (ModalService, $q) {
        return function (Datapoints) {
            console.debug('Probably deprecated! offsetValueModal called');
            return ModalService.showModal({
                templateUrl: "views/modals/editDatapoints.html",
                controller: 'offsetValueModalCtrl',
                inputs: {
                    Datapoints: Datapoints
                }
            });


        }
    }]);
